<div class="space-y-4">
  <div>
    <label class="label cursor-pointer justify-start gap-2" [for]="idPrefix + '-quota-max-custom'">
      <input
        [id]="idPrefix + '-quota-max-custom'"
        type="checkbox"
        class="checkbox checkbox-sm"
        [(ngModel)]="form.quotaMax.custom"
        [ngModelOptions]="{ standalone: true }"
      />
      <span class="label-text">Custom shopping allowance</span>
    </label>
    <input
      *ngIf="form.quotaMax.custom"
      [id]="idPrefix + '-quota-max'"
      type="number"
      step="1"
      [min]="quotaMaxMinimum"
      [(ngModel)]="form.quotaMax.value"
      [ngModelOptions]="{ standalone: true }"
      class="input w-full mt-1 rounded border-gray-300 shadow-sm"
      placeholder="Shopping allowance"
      aria-label="Shopping allowance"
    />
    <p class="mt-1 text-xs text-gray-500">
      The searches the application starts with each time the allowance resets. Each search uses one,
      and bookings earn them back at the look-to-book ratio, up to this amount. Enter -1 for
      unlimited searches.
    </p>
  </div>
  <!-- An unlimited allowance is never spent, so the ratio doesn't apply to it -->
  <div *ngIf="!unlimitedAllowance">
    <label
      class="label cursor-pointer justify-start gap-2"
      [for]="idPrefix + '-quota-renewal-rate-custom'"
    >
      <input
        [id]="idPrefix + '-quota-renewal-rate-custom'"
        type="checkbox"
        class="checkbox checkbox-sm"
        [(ngModel)]="form.quotaRenewalRate.custom"
        [ngModelOptions]="{ standalone: true }"
      />
      <span class="label-text">Custom look-to-book ratio</span>
    </label>
    <div *ngIf="form.quotaRenewalRate.custom" class="mt-1 flex items-center gap-2">
      <input
        [id]="idPrefix + '-quota-renewal-rate'"
        type="number"
        step="1"
        [min]="quotaRenewalRateMinimum"
        [(ngModel)]="form.quotaRenewalRate.value"
        [ngModelOptions]="{ standalone: true }"
        class="input w-full rounded border-gray-300 shadow-sm"
        placeholder="Searches per booking"
        aria-label="Look-to-book ratio, in searches per booking"
      />
      <span class="text-sm text-gray-700 whitespace-nowrap">: 1</span>
    </div>
    <p class="mt-1 text-xs text-gray-500">
      The searches earned back with each booking, up to the shopping allowance.
    </p>
  </div>
  <p *ngIf="error" class="text-sm text-error">{{ error }}</p>
</div>
